export default __webpack_public_path__ + "static/media/mn.52b9f2ce.svg";